// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"style__pageWrapper__XnIwn","buttonWrapper":"style__buttonWrapper__8d6Vn","showOverflow":"style__showOverflow__PRhSB","copyButton":"style__copyButton__ZIdCB"};